module.exports = __webpack_public_path__ + "img/mvlivelogo-white.3572ac48.svg";